import ErrorBoundary from './ErrorBoundary';
import Launcher from './Launcher';

export default function App() {
  return (
    <ErrorBoundary>
      <Launcher />
    </ErrorBoundary>
  );
}
